import type {
  ProcessDraftAssignment,
  ProcessDraftStep,
  ProcessStepRecordingDisplay
} from '@bliks-io/contracts';
import { DraftManualStepPanel } from './DraftManualStepPanel';
import { DraftAssignmentPanel } from './DraftAssignmentPanel';

interface Props {
  step?: ProcessDraftStep;
  assignment?: ProcessDraftAssignment;
  processId: string;
  /** The draft's start event — forwarded to the assignment panel's pickers. */
  startEventStableStepId?: string;
  siblingSteps: ProcessStepRecordingDisplay[];
  onClose: () => void;
}

/**
 * Dispatcher: the selected node is either a manual draft step or a draft
 * assignment. Exactly one of `step` / `assignment` must be provided; the
 * caller looks it up in the corresponding collection before rendering.
 */
export function DraftStepPanel({
  step,
  assignment,
  processId,
  startEventStableStepId,
  siblingSteps,
  onClose
}: Props) {
  if (step) {
    return (
      // Keyed per step: without it React reuses the panel instance across step
      // selections, leaking the previous step's picker drafts and pending
      // debounced field edits into the newly selected one.
      <DraftManualStepPanel
        key={String(step.stableStepId)}
        step={step}
        processId={processId}
        siblingSteps={siblingSteps}
        onClose={onClose}
      />
    );
  }
  if (assignment) {
    return (
      <DraftAssignmentPanel
        key={String(assignment.stableStepId)}
        assignment={assignment}
        processId={processId}
        startEventStableStepId={startEventStableStepId}
        siblingSteps={siblingSteps}
        onClose={onClose}
      />
    );
  }
  return null;
}
